import {getData, postData} from './redux_data';
import {
    GET_MOTIVO,
    MODIFY_MOTIVO,
    ADD_MOTIVO,
    DELETE_MOTIVO,
    UPDATE_MOTIVO,
} from '../constants/action_types';

export function getMotivo() {
    return getData('CvMotivos', GET_MOTIVO);
}

export function modifyMotivo(motivo) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_MOTIVO, payload: motivo });
    }
}

export function addMotivo(motivo) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_MOTIVO, payload: motivo });
    }
}

export function removeMotivo(motivo) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_MOTIVO, payload: motivo });
    }
}

export function updateMotivoDB (motivo) {
    return postData('CvMotivos/grupos', UPDATE_MOTIVO, motivo, 'Motivos actualizados', undefined);

}
